export const actions = {
  ADD_ITEM_TO_CART: "ADD_ITEM_TO_CART",
  ADD_ITEM_TO_WISHLIST: "ADD_ITEM_TO_WISHLIST",
  REMOVE_ITEM_FROM_WISHLIST: "REMOVE_ITEM_FROM_WISHLIST",
  INITIALIZE_LIST: "INITIALIZE_LIST",
  UPDATE_QUANTITY: "UPDATE_QUANTITY",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  PRICE_HIGH_TO_LOW: "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH: "PRICE_LOW_TO_HIGH",
  FILTER_OUT_OF_STOCK: "FILTER_OUT_OF_STOCK",
  FILTER_FAST_DELIVERY: "FILTER_FAST_DELIVERY",
  CLEAR_ALL_FILTERS: "CLEAR_ALL_FILTERS",
  UPDATE_SEARCH_TEXT: "UPDATE_SEARCH_TEXT",
  OPEN_OR_CLOSE_TOAST: "OPEN_OR_CLOSE_TOAST",
  UPDATE_PRICE_RANGE: "UPDATE_PRICE_RANGE",
};
